<template>
  <div class="error-page-container">
    <div
      class="error-page-main"
    >
      <img
        class="error-page-icon"
        src="//fe-img-qc.xhscdn.com/ae55fda63fc305ae4a1be78974fbf7577cb6d44f"
      >
      <p>你访问的页面不见了，你还可以</p>
    </div>
    <div class="error-page-actions">
      <div
        class="error-page-btn"
        @click="handleClickBack"
      >
        返回上一页
      </div>
    </div>
  </div>
</template>

<script>
  import { error } from '@xhs/logger'

  const artifactName = process.env.APP_NAME
  const artifactVersion = process.env.APP_VERSION
  export default {
    name: 'Launcher404Page',
    mounted() {
      error(
        `${window.location.pathname} not found in ${artifactName}-${artifactVersion}`,
        {
          path: window.location.pathname,
          fullPath: window.location.href,
          artifactName,
          artifactVersion,
        },
        this.$options.name,
      )
    },
    methods: {
      handleClickBack() {
        if (window.history.length === 1) {
          window.close()
        } else {
          window.history.go(-1)
        }
      },
    },
  }
</script>

<style lang="stylus" scoped>
  .error-page-container
    position fixed !important
    width 100% !important
    height 100%
    left 0
    top 0
    z-index 1001000
    background $BACKGROUND-COLOR
    .error-page-main
      height 220px
      margin-top 150px
      padding-top 30px
      font-size 15px
      text-align center
      color $LIGHT_MODE_GREY3
      p
        margin 15px 0 0
    .error-page-icon
      display inline-block
      width 120px
      height 120px
    .error-page-actions
      width 100%
      text-align center
      .error-page-btn
        margin-left auto
        margin-right auto
        background none
        border-radius 80px
        color $LIGHT_MODE_RED
        width 138px
        height 30px
        font-size 15px
        border 1px solid $LIGHT_MODE_RED
        line-height 28px
</style>
